/* eslint-disable no-unused-vars */
import { BackIcon, NotificationBell } from "../../Icons";
import {
  Badge,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { DRAWERS } from "../../../config/params";
import { INoticationListState } from "../../../state/notifications";
import { IRootState } from "../../../state";
import { IUserItemResponse } from "../../../services/user-detail/user-detail.interface";
import { InlineImportantHeader } from "../../../styles/styledComponents/Header.styled";
import Loading from "../../Loading/Loading";
import React from "react";
import { useBraze } from "../../../context/BrazeContext";
import { useDrawer } from "../../../context/DrawerContext";
import useNotificationsList from "../../../services/notifications/notifications.service";
import { useSelector } from "react-redux";
import { wellnessPlanNoBackgroundHeader } from "../../ContentLayout/ContentLayout.style";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { billCycle } from "../../../shared/containers/WellnessPlanPaymentContainer/types";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import useWellnessPurchaseData from "../../../hooks/redux-hooks/wellness-purchase-store/wellness-purchase-store";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { fromUnixToDate } from "../../../utils";

interface IPageTitle {
  showBackButton: boolean;
  pageTitle: string;
  user: IUserItemResponse;
  showNotificationIcon: boolean;
  mixpanelTrigger?: string;
  billCycle?: billCycle;
}

export const getSpeciesName = (speciesType: string) => {
  if (speciesType === "1") {
    return "Canine";
  }
  if (speciesType === "2") {
    return "Feline";
  }
};

const WellnessPlanTitle: React.FC<IPageTitle> = (props) => {
  const { showBackButton, pageTitle, user, mixpanelTrigger, billCycle } = props;

  const { loading } = useNotificationsList();
  const { openDrawer } = useDrawer();
  const { unviewedCount } = useBraze();
  const navigate = useNavigate();
  const { notificationsLists } = useSelector(
    (state: IRootState) => state.notications as INoticationListState,
  );
  const [searchParams] = useSearchParams();
  const petId = searchParams.get("id");
  const { petList } = usePetStore();
  const currentPet = petList?.filter((pet) => pet.id == petId);
  const { wellnessPurchaseData } = useWellnessPurchaseData();

  const handleNotificationDrawer = () => {
    openDrawer(DRAWERS.NOTIFICATIONS);
  };

  const handleOnBack = () => {
    if (petId && mixpanelTrigger && currentPet) {
      const planType = "Annual";

      if (
        mixpanelTrigger === MIXPANEL_EVENTS.BACK_BUTTON_CLICK_CONFIRM_PAY &&
        wellnessPurchaseData
      ) {
        userActivityLogger(mixpanelTrigger, {
          pet_id: petId,
          pet_name: currentPet[0].name,
          species: getSpeciesName(currentPet[0]?.species),
          plan_type: planType,
          selected_plan: wellnessPurchaseData.planType,
          dob: fromUnixToDate(parseInt(currentPet[0].birthdate)),
        });
      } else {
        userActivityLogger(mixpanelTrigger, {
          pet_id: petId,
          pet_name: currentPet[0].name,
          species: getSpeciesName(currentPet[0]?.species),
          plan_type: planType,
        });
      }
    }
    navigate(-1);
  };

  const getPageTitle = (pageTitle: string, currentPet: IPetItemResponse[] | undefined) => {
    switch (pageTitle) {
    case "Plan Details": return <span>Choose The Right Plan</span>;
    default:
      return <span>{pageTitle}</span>;
    }
  };

  return (
    <Box
      component="section"
      sx={wellnessPlanNoBackgroundHeader}
      className="flex justify-between !w-full"
    >
      <Box className="flex items-center gap-3">
        {showBackButton && (
          <Box className="link" onClick={handleOnBack}>
            <Box>
              <BackIcon width={20} height={20} />
            </Box>
          </Box>
        )}
        <Typography variant="h1">
          {location.pathname === "/dashboard" ? (
            <>
              {pageTitle}{" "}
              <InlineImportantHeader>{user.firstName} !</InlineImportantHeader>{" "}
            </>
          ) : getPageTitle(pageTitle, currentPet)}
        </Typography>
      </Box>
      {props.showNotificationIcon ? (
        <IconButton
          onClick={handleNotificationDrawer}
          sx={{ "&: hover": { background: "transparent" } }}
        >
          <Badge
            color="error"
            badgeContent={
              loading ? (
                <Loading size={12} />
              ) : (
                (notificationsLists?.totalUnreadNotifications || 0) + unviewedCount
              )
            }
            max={9}
          >
            <NotificationBell width={24} height={24} />
          </Badge>
        </IconButton>
      ) : (
        <Box></Box>
      )}
    </Box>
  );
};

export default WellnessPlanTitle;
